import { lazy, Suspense } from "react";
import ReactDOM from "react-dom/client";

import AppLoader from "./AppLoader";
import { applyThemeVars, getInitialScheme } from "./components/themeToggle";
import "./index.scss";

// Aplica o tema salvo cedo para o AppLoader (Suspense fallback) herdar as
// variáveis CSS corretas antes que o bundle do toolkit monte e injete os tokens.
// Mesmo helper usado pelo toggle (fonte única das cores) — ver applyThemeVars.
applyThemeVars(getInitialScheme());

const App = lazy(() => import("./App"));

const root = ReactDOM.createRoot(document.getElementById("root") as HTMLElement);
root.render(
	<Suspense fallback={<AppLoader />}>
		<App />
	</Suspense>,
);
